import { Disposer } from './Disposer';

export function combineDisposers(disposers: Disposer[])
{
    return () =>
        disposers.forEach(
            dispose =>
                dispose());
}
